import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { PageHeader } from 'src/components/common/page-header';
import { RoleForm } from 'src/components/roles/form';
import { Routes } from 'src/components/common/router/constants';
import { useRoleById } from 'src/hooks/query/permissions/roles/use-role-by-id';

export const RoleListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const { id } = useParams();

  const title = !id
    ? t('roles.form.add-permission-group')
    : t('roles.form.edit-permission-group');

  const breadCrumbsProps = {
    items: [
      {
        label: t('roles.breadcrumbs.roles'),
        url: Routes.roles.path,
      },
      {
        label: title,
      },
    ],
  };

  const { role, loading } = useRoleById({ id: id as string });

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      {!loading && <RoleForm role={role} onClose={goBack} onFinish={goBack} />}
    </>
  );
};

export default RoleListPage;
